import React from 'react';

function TopDigitalMarketingAgency() {
  return (
    <section className="dig-results-section">
      <div className="container dig-results-container">
        {/* Left Column: Content */}
        <div className="dig-results-left">
          <div className="dig-agency-header">
            <div className="dig-agency-red-bar"></div>
            <h2 className="dig-agency-title">
              Top <span className="text-red">Digital Marketing Agency</span><br />
              That Deliver Results
            </h2>
          </div>

          <p className="dig-agency-desc">
            Present-day digital marketing is not like traditional advertising. The best digital marketing agency services require a complete, data-driven approach that connects your brand with customers. Our digital marketing agency in Karachi creates professional campaigns that combine <a href="/seo-services/" className="dig-agency-highlight-link">search engine optimization</a>, <a href="/social-media-marketing/" className="dig-agency-highlight-link">social media marketing</a>, and content strategy to maximize your online presence for your business growth. Our team improves your identity and allows your business to grab high-intent prospects. You can also create customer relationships and change your digital channels into revenue-generating platforms with our online marketing company.
          </p>

          <p className="dig-agency-desc">
            Get professional digital marketing solutions to multiply your returns with online campaigns.
          </p>
        </div>

        {/* Right Column: Image */}
        <div className="dig-results-right">
          <div className="dig-agency-img-wrapper">
            <img
              src="/assets/images/digital-marketing/dig-img2.jpg"
              alt="Top Digital Marketing Agency That Deliver Results"
              className="dig-agency-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default TopDigitalMarketingAgency;
